import { derived } from 'svelte/store';
import type { SubcategoryTranslationKey } from './types';
import { getMessage, interpolate } from '../i18n/utils';
import data from './data.json';
import { defaultLang, regionLanguage } from '$lib/lang';

const strings: Record<string, Record<string, string>> = data;

export const messages = derived(regionLanguage, ($regionLanguage) => {
  return strings[$regionLanguage] || strings[defaultLang];
});

export const sub_categories = derived(messages, ($messages) => {
  return function translate(key: SubcategoryTranslationKey, values: Record<string, string> = {}) {
    return interpolate(getMessage($messages, key), values);
  };
});
